'use strict';

import { app } from '../../../bootstrap/core';

import { addSecuritiesComponent } from './addSecurities.component';
import addSecuritiesService from './addSecurities.service';

app.component('addSecuritiesComponent', addSecuritiesComponent);
app.service('addSecuritiesService', addSecuritiesService);


// WEBPACK FOOTER //
// ./src/app/common/ui/addSecurities/addSecurities.js